import { Container } from 'react-bootstrap'
import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import FavoriteFilter from './components/favorite/FavoriteFilter'
import FooterNew from './components/Footer'
import { useStore } from '../app/stores/store'
import FavoriteCard from './components/favorite/FavoriteCard'
import AuctionCard from './components/auction/AuctionCard'
import FavoriteCardPost from './components/favorite/FavoriteCardPost'
import PostCard from './components/post/PostCard'
import ComponentLoader from './components/loaders/ComponentLoader'
import CustomPagination from './components/buttons/CustomPagination'

function FavoritesPage() {
  const { favoriteAuctionsStore } = useStore()
  const { favorites, loadingFavorites, isAuction, isPost } = favoriteAuctionsStore
  const [page, setPage] = useState(1)
  const paginateLength = 9
  const { t } = useTranslation()

  if (loadingFavorites) return <ComponentLoader mTop={100} />

  function paginate(array: any) {
    return array.slice((page - 1) * paginateLength, page * paginateLength)
  }

  return (
    <>
      <FavoriteFilter />
      <Container fluid className='auction-container'>
        <div className='auction-content'>
          {favorites.length === 0 && <h1 className='mt-5 text-center'>{t('favorites_page.no_fav')}</h1>}
          <div className='favorite-big-card flex-column gap-3'>
            {paginate(
              favorites.map((data) =>
                isAuction(data) ? (
                  <FavoriteCard key={data.id} auction={data} />
                ) : isPost(data) ? (
                  <FavoriteCardPost key={data.id} post={data} />
                ) : null,
              ),
            )}
          </div>
          <div className='auction-list mb-5 favorite-small-card'>
            {paginate(
              favorites.map((data, index) =>
                isAuction(data) ? (
                  <AuctionCard key={index} auction={data} />
                ) : isPost(data) ? (
                  <PostCard key={index} post={data} />
                ) : null,
              ),
            )}
          </div>
          <br />
          <CustomPagination
            page={page}
            setPage={setPage}
            arrayLength={favorites.length}
            paginateLength={paginateLength}
          />
        </div>
      </Container>
      <FooterNew />
    </>
  )
}
export default observer(FavoritesPage)
